/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface JobUpdateRequest { 
    /**
     * The action to take for the job. One of the following values: SUSPEND, RESUME
     */
    action: JobUpdateRequest.ActionEnum;
}
export namespace JobUpdateRequest {
    export type ActionEnum = 'SUSPEND' | 'RESUME';
    export const ActionEnum = {
        SUSPEND: 'SUSPEND' as ActionEnum,
        RESUME: 'RESUME' as ActionEnum
    };
}
